import { Mensaje } from '@fenix/catalogo-mensajes';
export interface Mensajes {
  errorGeneral: Mensaje;
}
export const CatalogoMensaje = {
  successmessage: `Al completar tu <b>Estado de Situación,</b> puedes agregar algunos <b>datos no obligatorios</b> que
                            te ayudarán a entregar una visión más completa.`,
  infoIdentidad: `Antes de comenzar y por tu propia seguridad, debemos <b>validar tu identidad.</b> Para
  ello te pediremos datos como el número de documento de tu cédula y luego te haremos algunas preguntas.`,
  mensajeErrorCelular: 'Celular no está registrado.',
  servicioIntermitente:
    'El servicio presenta intermitencias. Por favor, intenta nuevamente en unos minutos.',
  AnalyticsMensajeIntermitencia: 'el servicio presenta intermitencia',
  mensajeValidaDatosError: 'no pudimos validar tus datos',
  mensajeRespuestaIncorrecta: 'al menos una de las respuestas no es correcta',
  mensajeErrorBloqueo:
    'No pudimos validar tus datos. Verifica que el número de serie sea el correcto,' +
    'que tu cédula esté vigente, no vencida ni bloqueada. Al cuarto intento se bloqueará por 24 horas.'
};
